<script>
	import { onDestroy, setContext, getContext } from 'svelte'
	import { routes } from './routes/Index.svelte'
	import { styles } from './library/scripts/styles.js'
	import Router from 'svelte-spa-router'
	import Shader from './library/ShadersAndSpinners/Shader.svelte'
	import CookieShader from './library/ShadersAndSpinners/CookieShader.svelte'
	import Spinner from './library/ShadersAndSpinners/SpinnerCircle.svelte'
	import ModalList from './modals/ModalList.svelte'
	import Alert from './modals/Alert.svelte'

	//detect mobile app
	const isMobile = 'ontouchstart' in document.documentElement && navigator.userAgent.match(/Mobi/)
	let isMobi = false
	if (isMobile && isMobile.length > 0) isMobi = true

	const fsS = 'clamp(16px, 1.9vw, 30px'
	const colorActive = 'hsl(22,86%,57%)'

	// global params
	setContext('globals', {
		//devices sizes
		devWidth: window.innerWidth,
		devHeight: window.innerHeight,
		//mobile apps (used to hide sliders)
		mobile: isMobi,
		// font sizes
		fsXXL: 'clamp(0.8rem, 5.8vw, 5rem)',
		fsXL: 'clamp(0.8rem, 4.1vw, 3.5rem)',
		fsX: 'clamp(0.6rem, 2.3vw, 2rem)',
		fsL: 'clamp(0.6rem, 1.5vw, 1.5rem)',
		fsN: 'clamp(0.4rem, 1.1vw, 1rem)',
		fsS: 'clamp(0.4rem, 1vw, 0.9rem)',
		fsXS: 'clamp(0.4rem, 0.9vw, 0.7rem)',
		//colors
		colorMain: 'hsl(0, 0%, 80%)',
		colorDark: 'hsl(0, 0%, 55%)',
		colorActive: 'hsl(22, 86%, 57%)',
		colorError: 'hsl(17, 100%, 53%)',
		colorOk: 'hsl(110, 87%, 50%)',
		//backgrounds
		bgShader: 'hsl(0, 0%, 0%)',
		bgLight: 'hsl(209, 36%, 35%)',
		bgDark: 'hsl(209, 28%, 28%)',
		//links
		link: 'hsl(200, 80%, 50%)',
		linkHover: 'hsl(200, 80%, 80%)',
		//Buttons
		buttonColor: 'white',
		buttonHover: 'hsl(209, 36%, 38%)',
		buttonBg: 'none',
		buttonBgHover: 'hsl(209, 36%, 40%)',
		buttonSmallColor: 'white',
		buttonSmallHover: 'white',
		buttonSmallBg: 'hsl(209, 28%, 25%)',
		buttonSmallBgHover: 'hsl(209, 28%, 35%)',
		//hamburger menu
		hamburgerMenu: 'hsl(209, 28%, 30%)',
		//select tag
		selectHover: 'hsl(209, 28%, 40%)',
		selectTitle: 'hsl(0, 0%, 100%)',

		//select popup bg
		optionBg: 'hsl(209, 28%, 30%)',
		//shadow
		boxShadow: 'black',
		//tool colors
		mainTool: 'hsl(0, 0%, 80%)',
		mainToolHover: 'hsl(0, 0%, 90%)',

		subTool: 'hsl(38, 31%, 44%)',
		subToolHover: 'hsl(38, 31%, 54%)',

		//navigation
		navHeight: 'clamp(35px, 5vw, 79px)',
		navBg: 'hsl(209, 28%, 25%)',
		//container
		containerLandscape: '100vh',
		containerPortrait: 'clamp(150px, 30vh, 400px',
		//modal windows
		modalWidth: 'clamp(300px, 80vw, 1229px)',
		modalSmallWidth: 'clamp(300px, 30vw, 461px)',
		modalContent: 'fit-content',
		modalHeader: 'clamp(35px, 5vw, 100px)',
		modalBg: 'hsl(209, 28%, 30%)',
		//form items
		inputBg: 'hsl(209, 28%, 25%)',
		inputBgFocus: 'hsl(209, 28%, 30%)',
		inputWidth: 'clamp(200px, 50vw, 768px)',
		inputSmallWidth: 'clamp(260px, 23vw, 420px)',
		inputBorder: 'hsl(142, 74%, 54%)',

		//icons
		icon: 'clamp(25px, 2.85vw, 44px)',
		iconSmall: 'clamp(14px, 1.28vw, 24px)',
		iconLarge: 'clamp(40px, 6vw, 93px)',

		//session storage name
		storageGeneral: 'kbt-general',
		storagePersonal: 'kbt-personal',

		//fonts
		fontSize: ['XX-LARGE', 'X-LARGE', 'LARGE', 'NORMAL', 'SMALL', 'X-SMALL'],
		fontSizeSmall: ['LARGE', 'NORMAL', 'SMALL', 'X-SMALL'],
		fontSizeXSmall: ['SMALL', 'X-SMALL'],
		fontFamily: [
			'Helvetica Neue, sans-serif',
			'Arial Black, serif',
			'Roboto, sans-serif',
			'Montserrat, sans-serif',
			'Caveat, sans-serif',
			'Verdana, Geneva, Tahoma, sans-serif',
			'Courier New, Courier, monospace',
			'Times New Roman, Times, serif',
			'Lucida Sans',
			'Lucida Handwriting, sans-serif',
			'Comic Sans MS,cursive',
		],

		//carets
		caretLarge: 'clamp(20px, 2.9vw, 45px)',

		// for admin pages
		adminBgDark: 'hsl(0, 0%, 80%)',
		adminColorMain: 'hsl(0,0%,10%)',
		adminInputBgFocus: 'hsl(0,0%,75%)',
		adminSelectTitle: 'hsl(0,0%,10%)',
		adminInputBorder: 'hsl(0,0%,10%)',
		adminInputBg: 'hsl(0,0%,70%)',
		adminOptionBg: 'hsl(0,0%,65%)',
		adminSelectHover: 'hsl(0,0%,85%)',
		adminButtonColor: 'hsl(0,0%,10%)',
		adminButtonBg: 'hsl(0,0%,70%)',
		adminButtonBgHover: 'hsl(0,0%,75%)',

		// the builder toolbar
		builderToolbar: 'hsl(0,0%,70%)',
		builderToolbarHover: 'hsl(200,50%,60%)',
	})

	let winLoad = false

	//check if cookies are enabled
	let cookieSetting
	if (navigator.cookieEnabled) cookieSetting = true
	else cookieSetting = false
	const window_loaded = () => {
		winLoad = true
	}
	const close_cookie_alert = () => {
		cookieSetting = true
	}

	const globals = getContext('globals')
	const inputBgFocus = globals.inputBgFocus
	onDestroy(() => {
		stoNavVisible
	})
</script>

<svelte:window on:load={window_loaded} />

{#if !winLoad}
	<Shader opacity=".9">
		<div slot="content" class="spinner_container">
			<Spinner color={inputBgFocus} />
			<div class="load_site" use:styles={{ fsS, colorActive }}>site loading</div>
		</div>
	</Shader>
{/if}

{#if !cookieSetting}
	<CookieShader>
		<div slot="content">
			<Alert
				message="This site uses cookies to work properly, please enable cookies in your browser settings!!"
				on:alertclose={close_cookie_alert}
				showOkButton={false}
			/>
		</div>
	</CookieShader>
{/if}

<Router {routes} />
<ModalList />

<style>
	.load_site {
		font-size: var(--fsS);
		color: 'hsl(0,0%,60%)';
	}

	.spinner_container {
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		width: 100vw;
		font-size: 20px;
		color: white;
	}
</style>
